import { StoreModule } from '@ngrx/store';
import { companyReducer } from './company.reducer';
import { CompanyFeatureKey } from './company-feature-key';

export * from './company-feature-key';
export * from './company.actions';
export * from './company.effects';
export * from './company.reducer';
export * from './company.selectors';

export const CompanyStoreModule = StoreModule.forFeature(
  CompanyFeatureKey,
  companyReducer
);
